import { BRANDS } from "shared/constants/brands";
import "styles/components/common/notFoundPage.css";

export default function NotFoundPage({
  dataTheme = `${BRANDS[0]}-light`,
}: {
  dataTheme?: string;
}) {
  return (
    <div className="not-found-container" data-theme={dataTheme}>
      <h1 className="error-code">404</h1>
      <p className="error-not-found-message">
        Oops! The widget you're looking for doesn't exist.
      </p>
    </div>
  );
}
